import redesignedTheme from '../../../../theme/news12-redesign'

import css from 'styled-jsx/css'

export default css.div`

  .card {
    flex: 0 0 auto;
    display: flex;
    width: 350px;
    margin-bottom: 24px;
  }
  
  .card-content {
    display: flex;
    flex-direction: column;
  }
  
  .top {
    order: -1;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin: 5px 0 9px;
  }
  
  .card-title {
    order: 3;
    display: flex;
    margin: 8px 0 24px;
    font-size: 20px;
  }
  
  .meatball-icon {
    padding: 0;
  }
  
  .play-icon {
    margin-bottom: 2px;
  }  
  
  .top-stories .card {
    border-bottom: 3px solid ${redesignedTheme.colors.mist};
  }  
  
  .top-stories .card:nth-of-type(3) {
    padding-right: 10px;
  }  
  
  .top-stories .card:nth-of-type(4) {
    padding-left: 10px;
  }
`
